import "./App.css";
function Club() {
	// all the cards image
	const cards = [
		{ image: "gellary/gellary (1).png" },
		{ image: "gellary/gellary (2).png" },
		{ image: "gellary/gellary (3).png" },
		{ image: "gellary/gellary (4).png" },
		{ image: "gellary/gellary (5).png" },
		{ image: "gellary/gellary (6).png" },
		{ image: "gellary/gellary (7).png" },
		{ image: "gellary/gellary (8).png" },
		{ image: "gellary/gellary (9).png" },
	];
	return (
		<div id="gellary" className="Club-section h-full ">
			<div className="">
				{/* <img className="w-full " src={sectionTwo} alt="hero" /> */}
				<div className=" w-full text-2xl text-[#FFF36A] font-['italic'] uppercase flex justify-center items-center md:text-3xl ">
					<h2 className="bg-[#F65FE9] px-5 py-1 shadow-lg rounded-3xl ">
						compra aqui
					</h2>
				</div>
				<div className=" flex justify-center flex-wrap pt-20">
					{cards.map((card) => (
						<div className="w-full md:w-1/2 lg:w-[26%] xl:w-[26%] py-3 flex items-center justify-center">
							<div className="w-full rounded-lg shadow-lg">
								<img className="xl:w-full" src={card.image} alt="card" />
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
}
export default Club;
